module.exports = __webpack_public_path__ + "Breymont-Bold.7cf2aeb2939770c1a8fd.ttf";


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/assets/scss/fonts/Breymont-Bold.ttf
// module id = ../../../../../src/assets/scss/fonts/Breymont-Bold.ttf
// module chunks = styles